import './Loader.scss';
import LogoImage from '../assets/logo/IconOnly_Transparent_NoBuffer.png';

const Loader = ({ isLoading = false }) => {
  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-container">        
            <img className="mashlom-loader breath-animation" src={LogoImage} alt="Loading..." />        
      </div>
    </div>
  );
};

export default Loader;
